import { createApiCall2, MethodType, URI, createApiCall } from "../Api";
import { UserListBusinessPayload } from "models/userListBusiness/usersListBusiness";
import { IUpdateUserStatusPayload } from "models/userListBusiness/updateUserStatus";
import { IDeleteBusinessUserPayload } from "models/userListBusiness/deleteBusinessUser";
import { IUpdateUserDepartmentPayload } from "models/userListBusiness/updateUserDepartment";
import { IUpdateReleaseDatePayload } from "models/userListBusiness/updateReleaseDate";

export const fetchDepartmentList = () => {
  return createApiCall2(MethodType.GET, URI.USER_LIST_BUSINESS.DEPARTMENT_LIST);
};

export const getUserListBusiness = (payload: UserListBusinessPayload) => {
  return createApiCall2(
    MethodType.GET,
    URI.USER_LIST_BUSINESS.USER_LIST,
    payload
  );
};

export const updateUserStatus = (payload: IUpdateUserStatusPayload) => {
  return createApiCall2(
    MethodType.PUT,
    URI.USER_LIST_BUSINESS.UPDATE_USER_STATUS,
    payload
  );
};

export const deleteBusinessUser = (payload: IDeleteBusinessUserPayload) => {
  return createApiCall2(
    MethodType.DELETE,
    URI.USER_LIST_BUSINESS.DELETE_BUSINESS_USER,
    payload
  );
};

export const updateUserDepartment = (payload: IUpdateUserDepartmentPayload) => {
  return createApiCall2(
    MethodType.PUT,
    URI.USER_LIST_BUSINESS.UPDATE_USER_DEPARTMENT,
    payload
  );
};

export const updateReleaseDate = (payload: IUpdateReleaseDatePayload) => {
  return createApiCall2(
    MethodType.PUT,
    URI.USER_LIST_BUSINESS.UPDATE_RELEASE_DATE,
    payload
  );
};

export const downloadBusinessUserCSV = () => {
  return createApiCall2(
    MethodType.GET,
    URI.USER_LIST_BUSINESS.DOWNLOAD_BUSINESS_USER_CSV
  );
};
